@use '../../../common/styles/variables' as *;
@use '../../../common/mixins/buttons' as *;

:host {
  display: block;
  @include default-css-variables;
  width: inherit;
}

div.nylas-event-timeslot {
  label {
    display: flex;
    align-items: center;
    color: var(--nylas-base-800);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }

  div.date-time-input {
    div.date-time-picker {
      display: flex;
      gap: 32px;

      @media #{$mobile} {
        flex-direction: column;
        gap: 16px;
      }

      nylas-date-component {
        width: 224px;

        @media #{$mobile} {
          width: 100%;
        }
        &:not(.error) {
          &::part(ic__date) {
            border-color: var(--nylas-base-200);
          }
        }
        &::part(ic__date) {
          height: 50px;
        }
      }

      div.time-range {
        display: flex;
        gap: 8px;
        align-items: flex-start;

        span {
          margin: 12px 0 0 6px;
          display: inline-flex;
          align-items: flex-start;
        }

        @media #{$mobile} {
          display: grid;
          grid-template-columns: 1fr 20px 1fr;

          nylas-time-window-picker {
            &::part(time-picker) {
              width: -webkit-fill-available;
            }

            &::part(time-input) {
              width: calc(100% - 8px);
            }
          }
        }
      }

      select-dropdown {
        width: fit-content;

        &::part(sd_dropdown) {
          position: relative;
        }

        &::part(sd_dropdown-button) {
          border: none;
          padding: 14px;
          justify-content: flex-start;

          &:hover {
            border: none;
            outline: none;
            color: var(--nylas-primary);
          }
        }

        @media #{$mobile} {
          width: -webkit-fill-available;

          &::part(sd_dropdown-button-selected-label) {
            max-width: fit-content;
          }

          &::part(sd_dropdown-content) {
            right: unset;
            width: unset;
          }
        }
      }
    }

    div.recurrence-options {
      margin: 8px 0;

      select-dropdown {
        &::part(sd_dropdown) {
          position: relative;
        }

        &::part(sd_dropdown-button) {
          width: fit-content;
          padding: 14px;
          border-color: var(--nylas-base-200);

          &:hover {
            color: var(--nylas-primary);
          }
        }

        &::part(sd_dropdown-content) {
          width: fit-content;
        }

        &::part(sd_dropdown-button-selected-label) {
          max-width: 100%;
          width: fit-content;
          font-size: 16px;
        }

        @media #{$mobile} {
          width: -webkit-fill-available;

          &::part(sd_dropdown-button-selected-label) {
            max-width: 254px;
            width: fit-content;
          }

          &::part(sd_dropdown-content) {
            right: unset;
            width: unset;
          }
        }

        @media #{$x-small-mobile} {
          &::part(sd_dropdown-button-selected-label) {
            max-width: 240px;
          }
        }
      }

      div.custom-recurrence-time-period,
      div.recurrence-type,
      div.recurrence-end {
        display: grid;
        align-items: center;
        gap: 16px;
        grid-template-columns: 128px 1fr;
        margin-bottom: 8px;
        select-dropdown::part(sd_dropdown-button) {
          border-color: var(--nylas-base-200);
        }

        @media #{$mobile} {
          grid-template-columns: 1fr;
          gap: 4px;
          margin: 16px 0;
        }

        time-period-selector::part(id_dropdown-input) {
          padding: 16px;
        }
        time-period-selector input-dropdown {
          &:hover {
            border: 1px solid var(--nylas-primary);
            outline: 1px solid transparent;
          }
        }
      }

      div.repeat-on {
        div.days {
          margin: 16px 0;
          display: flex;
          gap: 16px;
          align-items: center;

          div.buttons {
            display: flex;
            gap: 8px;
            margin: 8px 0;

            button {
              border-radius: 50%;
              border: none;
              height: 24px;
              width: 24px;
              color: var(--nylas-base-800);
              cursor: pointer;
              background: var(--nylas-base-100);

              &:hover {
                background-color: var(--nylas-base-500);
                color: var(--nylas-base-0);
              }

              &.selected {
                background-color: var(--nylas-primary);
                color: var(--nylas-base-0);
              }

              &:active {
                background-color: var(--nylas-base-600);
                color: var(--nylas-base-0);
              }
            }
          }
        }

        div.days,
        div.custom-recurrence-ends,
        div.month-recurrence {
          display: grid;
          align-items: center;
          gap: 16px;
          grid-template-columns: 128px 1fr;

          @media #{$mobile} {
            grid-template-columns: 1fr;
            gap: 4px;
            margin: 16px 0;
          }
        }

        div.custom-recurrence-ends {
          #custom-recurrence-end-type {
            &::part(sd_dropdown-button) {
              padding: 16px;
            }
          }
        }

        div.custom-recurrence {
          display: flex;
          gap: 16px;
          align-items: baseline;

          @media #{$mobile} {
            flex-direction: column;
            align-items: flex-start;
            gap: 0;
          }

          div.custom-recurrence-end-after {
            display: flex;
            gap: 8px;
            align-items: center;

            @media #{$mobile} {
              flex-direction: column;
              align-items: flex-start;
            }
            #recurrence-end-after {
              &::part(netimeslot__input-textfield),
              &::part(ic__input) {
                border-color: var(--nylas-base-200);
              }
            }
          }

          nylas-date-component::part(ic__date) {
            padding: 0 16px;
            height: 52px;
            border: 1px solid var(--nylas-base-200);
          }
        }
      }
    }
  }
}
